import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["vehiclesList", "vehicleCard"]

  connect() {
    setTimeout(() => this.updateStatusCounts(), 100)
  }

  sortByStatus(event) {
    event.preventDefault()
    
    const targetStatus = event.currentTarget.dataset.status
    const sortType = event.currentTarget.dataset.sortType || 'vehicleState'
    
    if (!this.hasVehiclesListTarget) {
      return
    }
    
    const vehiclesList = this.vehiclesListTarget
    const cards = Array.from(this.vehicleCardTargets)

    if (cards.length === 0) {
      return
    }

    const targetCards = []
    const otherCards = []
    
    cards.forEach(card => {
      let cardStatus
      
      if (sortType === 'commStatus') {
        cardStatus = card.dataset.commStatus
      } else {
        cardStatus = card.dataset.vehicleState
      }
      
      if (cardStatus === targetStatus) {
        targetCards.push(card)
      } else {
        otherCards.push(card)
      }
    })
    
    targetCards.sort((a, b) => parseInt(a.dataset.vehicleId) - parseInt(b.dataset.vehicleId))
    otherCards.sort((a, b) => parseInt(a.dataset.vehicleId) - parseInt(b.dataset.vehicleId))
    
    const sortedCards = [...targetCards, ...otherCards]

    vehiclesList.innerHTML = ''
    
    sortedCards.forEach((card, index) => {
      vehiclesList.appendChild(card)
      card.style.transform = 'translateY(-5px)'
      card.style.opacity = '0.8'
      
      setTimeout(() => {
        card.style.transform = 'translateY(0)'
        card.style.opacity = '1'
        card.style.transition = 'transform 0.2s ease, opacity 0.2s ease'
      }, index * 30)
    })
    
    this.updateStatusCounts()
  }

  updateStatusCounts() {
    const allCards = Array.from(document.querySelectorAll('.vehicle-card'))
    
    let ignitionOnCount = 0
    let ignitionIdleCount = 0
    let ignitionOffCount = 0
    let commOkCount = 0
    let commFailCount = 0
    
    allCards.forEach(card => {
      const vehicleState = card.dataset.vehicleState
      const commStatus = card.dataset.commStatus
      
      if (vehicleState === 'on') ignitionOnCount++
      else if (vehicleState === 'idle') ignitionIdleCount++
      else ignitionOffCount++
      
      if (commStatus === 'ok') commOkCount++
      else if (commStatus === 'fail') commFailCount++
    })
    
    document.querySelectorAll('[data-status="on"]:not([data-sort-type]) span').forEach(span => {
      span.textContent = ignitionOnCount
    })
    
    document.querySelectorAll('[data-status="idle"]:not([data-sort-type]) span').forEach(span => {
      span.textContent = ignitionIdleCount
    })
    
    document.querySelectorAll('[data-status="off"]:not([data-sort-type]) span').forEach(span => {
      span.textContent = ignitionOffCount
    })
    
    document.querySelectorAll('[data-status="ok"][data-sort-type="commStatus"] span').forEach(span => {
      span.textContent = commOkCount
    })
    
    document.querySelectorAll('[data-status="fail"][data-sort-type="commStatus"] span').forEach(span => {
      span.textContent = commFailCount
    })
  }
}